export default "__VITE_ASSET__D4vP6zhg__"